import React, { useState } from "react";
import { Form, Select, Tag } from "antd";
import MapBase from "./MapBase";
import useMapProps from "./useMapProps";
import { MapPropsProvider } from "./MapPropsContext";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import WidgetTable from "./widgets/WidgetTable";
import WidgetContainer from "./widgets/WidgetContainer";
import { getApiUrl } from "../../utils";
import { Title } from "./widgets/Common";
import WidgetToolbar from "./widgets/WidgetToolbar";
import { TI_BROD_CH_COMBO_BOX, WELL_KNOWN_POSITION, TI_WIDGET_TABLE } from "../../Constants";
import WidgetLegend from "./widgets/WidgetLegend";
import EllipsisText from "./widgets/EllipsisText";
import { WidgetButton } from "../../styled-components/Button";

const MapShip = () => {
  const [isTableVisible, setTableVisible] = useState(false);
  const mapProps = useMapProps({
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: () => "선박국",
      getIconWidth: (d) => 30,
    },
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.대한민국,
      zoom: 7,
    },
  });

  const { setMapCenter, clickedPointIconObjects, filteredPointsResponseList } =
    mapProps;

  const allSelector = [
    {
      index: 0,
      uid: 9999,
      ship_name: "전체",
      position: [127.2855187, 36.4806503],
    },
  ];
  const optionList = allSelector.concat(filteredPointsResponseList[0]);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isHideWidgetToggleClustering={true}>
        <WidgetContainer>
          <div>
            {/*<WidgetDistrictSelect isShowDistrictLayerFromGeoserver={false}/>*/}
            {filteredPointsResponseList.length > 0 && (
              <Form.Item>
                <Title>어업정보 통신국</Title>
                <Select
                  style={{ width: "100%" }}
                  tabIndex={TI_BROD_CH_COMBO_BOX}
                  placeholder={"통신국을 선택해주세요."}
                  onChange={(position) => {
                    const [latitude, longitude] = position.split(",");
                    if (
                      latitude === "36.4806503" &&
                      longitude === "127.2855187"
                    ) {
                      setMapCenter({ latitude, longitude, zoom: 8 });
                    } else {
                      setMapCenter({ latitude, longitude, zoom: 14 });
                    }
                  }}
                >
                  {optionList
                    // .sort((rowA, rowB) => rowA.ship_name < rowB.ship_name ? -1 : 1)
                    .map(({ ship_name, position: [longitude, latitude] }) => (
                      <Select.Option
                        key={ship_name}
                        value={`${latitude},${longitude}`}
                      >
                        {ship_name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}
          </div>
        </WidgetContainer>
        <WidgetTableClicked
          fetchUrl={getApiUrl({ type: "type2" })}
          getTitle={(objects) => `${objects.length}개의 어업정보 통신국`}
          objects={clickedPointIconObjects}
          getRowTitle={({ rds_pms_nm }) => rds_pms_nm}
          getRow={({ rds_pms_nm, freq, rds_pms_adr }) => (
            <table>
              <tbody>
                <tr>
                  <th style={{ width: "15%" }}>주소</th>
                  <td>{rds_pms_adr}</td>
                </tr>
                <tr>
                  <th>주파수</th>
                  <td>
                    <div>
                      {freq.split(",").map((f) => (
                        <Tag
                          color={getFreqColor(f)}
                          key={f}
                          style={{ marginBottom: 3 }}
                        >
                          {f}
                        </Tag>
                      ))}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        />

        <WidgetTable
          visible={isTableVisible}
          setVisible={setTableVisible}
          fetchUrl={getApiUrl({ type: "type1" })}
          getTitle={(layer) => `${layer.length}개의 어업정보 통신국`}
          widgetTabIndex={TI_WIDGET_TABLE}
          columns={[
            {
              title: "통신국 이름",
              dataIndex: "rds_pms_nm",
              key: "rds_pms_nm",
              width: 150,
              fixed: "left",
              // sorter: makeTableSorterFn("rds_pms_nm"),
            },
            {
              title: "허가주소",
              dataIndex: "rds_pms_adr",
              key: "rds_pms_adr",
              width: 350,
              render: (rds_pms_adr) => (
                <WidgetButton>
                  <EllipsisText text={rds_pms_adr} />
                </WidgetButton>
              ),
              // sorter: makeTableSorterFn("rds_pms_adr"),
            },
            {
              title: "위도/경도",
              dataIndex: "lat",
              key: "lat",
              width: 150,
              render: (lat, record) => (
                <>
                  {record.lat}
                  <br />
                  {record.lon}
                </>
              ),
            },
            {
              title: "주파수",
              dataIndex: "freq",
              key: "freq",
              // sorter: makeTableSorterFn("freq"),
              render: (freq) =>
                freq.split(",").map((f) => (
                  <Tag
                    color={getFreqColor(f)}
                    key={f}
                    style={{ marginBottom: 3 }}
                  >
                    {f}
                  </Tag>
                )),
            },
            {
              title: "전화번호",
              dataIndex: "tel_no",
              key: "tel_no",
              width: 120,
              // sorter: makeTableSorterFn("tel_no"),
            },
          ]}
          horizontalScroll={1600}
        />

        <WidgetLegend />
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
};

const getFreqColor = (freq) => {
  return /khz/i.test(freq) ? "blue" : "volcano";
};

export default MapShip;
